import { render, staticRenderFns } from "./SwipedHomeBannerSmall.vue?vue&type=template&id=0cdee16a&scoped=true&"
import script from "./SwipedHomeBannerSmall.vue?vue&type=script&lang=js&"
export * from "./SwipedHomeBannerSmall.vue?vue&type=script&lang=js&"
import style0 from "./SwipedHomeBannerSmall.vue?vue&type=style&index=0&id=0cdee16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdee16a",
  null
  
)

export default component.exports